/**
 * Bucks Currency Converter - Rounding Override
 * Overrides Bucks CC app configuration to round off currency values
 */
(function() {
  'use strict';

  var settings = window.__bucksRoundingSettings || {
    enabled: true,
    roundingType: 'removeDecimal',
    roundingDecimal: '0.00',
    roundDefaultCurrency: true
  };

  if (!settings.enabled) {
    return;
  }

  var roundingType = settings.roundingType || 'removeDecimal';
  var roundingDecimal = parseFloat(settings.roundingDecimal != null ? settings.roundingDecimal : 0.00);
  if (isNaN(roundingDecimal)) {
    roundingDecimal = 0.00;
  }
  var roundDefaultCurrency = settings.roundDefaultCurrency !== false;

  function applyOverrides(config) {
    if (!config || typeof config !== 'object') return;

    config.priceRoundingType = roundingType;
    config.roundingDecimal = roundingDecimal;
    config.roundPriceStatus = true;
    config.defaultCurrencyRounding = roundDefaultCurrency;

    // Define properties to prevent other scripts from resetting them to 'none'
    try {
      Object.defineProperty(config, 'priceRoundingType', {
        get: function() { return roundingType; },
        set: function(val) { /* locked to override */ },
        configurable: true,
        enumerable: true
      });

      Object.defineProperty(config, 'roundingDecimal', {
        get: function() { return roundingDecimal; },
        set: function(val) { /* locked to override */ },
        configurable: true,
        enumerable: true
      });

      Object.defineProperty(config, 'roundPriceStatus', {
        get: function() { return true; },
        set: function(val) { /* locked to override */ },
        configurable: true,
        enumerable: true
      });

      Object.defineProperty(config, 'defaultCurrencyRounding', {
        get: function() { return roundDefaultCurrency; },
        set: function(val) { /* locked to override */ },
        configurable: true,
        enumerable: true
      });
    } catch (e) {
      // Fallback if defineProperty fails on object
    }
  }

  // Ensure window.bucksCC exists
  window.bucksCC = window.bucksCC || {};

  // If metaConfig exists already, apply overrides
  if (window.bucksCC.metaConfig) {
    applyOverrides(window.bucksCC.metaConfig);
  }

  // Intercept any future assignments to window.bucksCC.metaConfig
  var currentMetaConfig = window.bucksCC.metaConfig || {};
  applyOverrides(currentMetaConfig);

  try {
    Object.defineProperty(window.bucksCC, 'metaConfig', {
      get: function() {
        return currentMetaConfig;
      },
      set: function(newConfig) {
        currentMetaConfig = newConfig || {};
        applyOverrides(currentMetaConfig);
      },
      configurable: true,
      enumerable: true
    });
  } catch (e) {
    // If defineProperty fails, fall back to direct property
    window.bucksCC.metaConfig = currentMetaConfig;
  }

  // Function to trigger reconvert if Bucks SDK is loaded
  function triggerReConvert() {
    if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
      try {
        window.bucksCC.reConvert();
      } catch (err) {}
    }
  }

  // Listen to Bucks CC theme app extension load event
  if (typeof window.addEventListener === 'function') {
    window.addEventListener('BUCKSCC_THEME-APP-EXTENSION_LOADED', function() {
      if (window.bucksCC && window.bucksCC.metaConfig) {
        applyOverrides(window.bucksCC.metaConfig);
      }
      triggerReConvert();
    });

    window.addEventListener('load', function() {
      triggerReConvert();
    });
  }

  // Also apply on DOMContentLoaded and window load
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading' && typeof document.addEventListener === 'function') {
      document.addEventListener('DOMContentLoaded', function() {
        if (window.bucksCC && window.bucksCC.metaConfig) {
          applyOverrides(window.bucksCC.metaConfig);
        }
        triggerReConvert();
      });
    } else {
      triggerReConvert();
    }

    if (typeof document.addEventListener === 'function') {
      // Re-trigger on Shopify theme section events (e.g., variant change or section render)
      document.addEventListener('shopify:section:load', function() {
        triggerReConvert();
      });
    }
  }
})();
